import axios from "axios";

export default {
    namespaced: true,

    state: {
        keyword: undefined,
        currentPage: "1",
    },

    getters: {
        keyword: (state) => state.keyword,
        currentPage: (state) => state.currentPage,
    },

    mutations: {
        mutateKeyword(state, payload) {
            state.keyword = payload;
        },
        mutateCurrentPage(state, payload) {
            state.currentPage = payload;
        },
    },

    actions: {
        find({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/${id}`)
                    .then((res) => {
                        resolve(res.data.icds);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getChapters(_) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/icd/chapters")
                    .then((res) => {
                        resolve(res.data.chapters);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getChapterById(_, chapterId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/chapters/${chapterId}`)
                    .then((res) => {
                        resolve(res.data.chapter);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getChapterBlocks(_, chapterId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/chapters/${chapterId}/blocks`)
                    .then((res) => {
                        resolve(res.data.blocks);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getBlockById(_, blockId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/blocks/${blockId}`)
                    .then((res) => {
                        resolve(res.data.block);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getChildBlocks(_, blockId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/blocks/${blockId}/children`)
                    .then((res) => {
                        resolve(res.data.blocks);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getBlockSections(_, blockId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/blocks/${blockId}/sections`)
                    .then((res) => {
                        resolve(res.data.sections);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getSectionById(_, sectionId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/sections/${sectionId}`)
                    .then((res) => {
                        resolve(res.data.section);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getSectionDiseases(_, sectionId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/sections/${sectionId}/diseases`)
                    .then((res) => {
                        resolve(res.data.diseases);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getDiseaseById(_, diseaseId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/icd/diseases/${diseaseId}`)
                    .then((res) => {
                        resolve(res.data.disease);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        search({ commit, state }, url) {
            let currentPage = state.currentPage;
            if (typeof url === "string") {
                const routeParts = url.split("page=");
                if (routeParts.length > 1) {
                    currentPage = routeParts[1];
                }
            }
            return new Promise((resolve, reject) => {
                axios
                    .post(`/medico/icd?page=${currentPage}`, {
                        keyword: state.keyword,
                    })
                    .then((response) => {
                        commit("mutateCurrentPage", currentPage);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
